import { Media, Story } from '../../../schema';
import { Dispatch, SetStateAction, useState } from 'react';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

export interface StoryElementProps {
  story: Story;
  setEditing: Dispatch<SetStateAction<boolean>>;
  isAnyStoryEditing?: boolean;
}

const mediaUrl = (tripId: string, media: Media) =>
  `https://media.${process.env.REACT_APP_HOST}/${tripId}/${media.id}-thumbnail.${media.ext}`;

export const StoryElement = (props: StoryElementProps) => {
  const [locale] = useState(navigator.language);

  const date = locale.startsWith('de')
    ? format(new Date(props.story.date), 'd. MMMM yyyy', { locale: de })
    : format(new Date(props.story.date), 'MMMM d, yyyy', { locale: enUS });

  return (
    <>
      <div className="flex items-center justify-center relative text-sm">
        {!props.isAnyStoryEditing && (
          <div className="absolute right-0">
            <button
              className="px-2 py-1 bg-indigo-600 text-white rounded"
              onClick={() => props.setEditing(true)}
            >
              Edit
            </button>
          </div>
        )}
        <div className="flex items-center space-x-2">
          <p>{date}</p>
          {props.story.place && <span>&bull;</span>}
          {props.story.place && <p>{props.story.place}</p>}
        </div>
      </div>
      <h2 className="mt-1 text-2xl/7 text-center font-extrabold">{props.story.title}</h2>
      <p className="mt-4 text-md text-center whitespace-pre-line">{props.story.description}</p>
      <div className="mt-6 flex flex-wrap gap-1 justify-center">
        {props.story.medias.map((media: Media) => (
          <img
            key={media.id}
            className="max-h-[200px] w-auto sm:max-w-none max-w-[40vw] rounded-xl object-cover"
            src={mediaUrl(props.story.tripId, media)}
          />
        ))}
      </div>
    </>
  );
};
